export default __webpack_public_path__ + "static/media/flag-south-georgia-and-the-south-sandwich-islands.683cb6e8.svg";